exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".LagoCheckins_more_items_title{font-weight:bold;margin-top:10px}\n", ""]);

// Exports
exports.locals = {
	"more_items_title": "LagoCheckins_more_items_title"
};